import type React from 'react';

import { ToastProvider } from '#src/app/shared/toast';

import { BannerContainer } from '../containers/BannerSection';
import { DetailsContainer } from '../containers/Details';

import { useShowSurvey } from './hooks/useShowSurvey';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useShowSurvey();

	return (
		<ToastProvider>
			<BannerContainer />
			<DetailsContainer />
		</ToastProvider>
	);
};
